import React, {FC} from "react"

import {Body, H3} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

import {StyledCard} from "../styled"

const PaymentSuccess: FC = () => {
  const theme = useTheme()
  const {formatMessage} = useIntl()
  return (
    <StyledCard maxWidth="600px" marginTop="50px">
      <Flex direction="column" gap={2} alignItems="center">
        <img src={formatMessage({id: "platform.selfSignUp.paymentSuccess.img"})} height={150} width={150} />
        <H3 textAlign="center" color={theme.colors.primary2}>
          <FormattedMessage id="platform.selfSignUp.paymentSuccess.title" />
        </H3>
        <Body small textAlign="center" color={theme.colors.primary2}>
          <FormattedMessage id="platform.selfSignUp.paymentSuccess.subTitle" />
        </Body>
      </Flex>
    </StyledCard>
  )
}

export default PaymentSuccess
